//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { DISTRIBUTION_ENDPOINTS } from '@apis/content-library/contentLibraryApiModel';
import { GalleriesClientType } from '@galleries/selectors/getGalleriesClientType';
import { VISUAL_SYNDICATION_NETWORK } from '@galleries/selectors/getSelectedGalleryName';

export const getDistributionEndpointLabel = (
  endpoint: DISTRIBUTION_ENDPOINTS,
  galleriesClientType: GalleriesClientType,
  isConnectClient?: boolean,
) => {
  const getFanreelEndpoint = () => {
    if (
      // Always use 'Galleries' instead of 'Fanreel' for connect clients
      isConnectClient ||
      galleriesClientType === GalleriesClientType.galleries ||
      galleriesClientType === GalleriesClientType.custom
    ) {
      return 'Galleries';
    } else if (galleriesClientType === GalleriesClientType.instashop) {
      return 'InstaShop';
    }
    return '';
  };

  switch (endpoint) {
    case DISTRIBUTION_ENDPOINTS.fanreel:
      return getFanreelEndpoint();
    case DISTRIBUTION_ENDPOINTS.like2Buy:
      return 'Instagram Like2Buy';
    case DISTRIBUTION_ENDPOINTS.tiktokLike2Buy:
      return 'TikTok Like2Buy';
    case DISTRIBUTION_ENDPOINTS.connect:
      return VISUAL_SYNDICATION_NETWORK;
    default:
      return endpoint;
  }
};
